"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var slice_1 = require("./slice");
Object.defineProperty(exports, "carPoliciesReducer", { enumerable: true, get: function () { return slice_1.default; } });
//# sourceMappingURL=index.js.map